// extracted by mini-css-extract-plugin
export default {"userTypeCard":"user-type-modal_userTypeCard__O4BC2","cardTitle":"user-type-modal_cardTitle__DNl2z"};